import { Box } from '@mui/material'
import React from 'react'

// Componente que muestra en que pagina menciona donde se encuentra el usuario
const HeadingTitle = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "35px"}} className='heading-title__background' >
      <p>Demanda en Línea, Juzgado Especializado en Violencia Familiar</p>
    </Box>
  )
}

export {HeadingTitle}